import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface AvatarConfig {
  avatarId: string;
  bgColor: string;
}

@Component({
  selector: 'app-avatar-picker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar-picker.component.html',
  styleUrl: './avatar-picker.component.scss'
})
export class AvatarPickerComponent {
  @Input() currentAvatar: AvatarConfig = { avatarId: 'face1', bgColor: '#22C55E' };
  @Output() avatarChanged = new EventEmitter<AvatarConfig>();

  isOpen = false;
  selectedAvatar: string = 'face1';
  selectedBg: string = '#22C55E';

  readonly avatars: { id: string; label: string }[] = [
    { id: 'face1', label: 'Sonrisa' },
    { id: 'face2', label: 'Cool' },
    { id: 'face3', label: 'Guino' },
    { id: 'face4', label: 'Feliz' },
    { id: 'face5', label: 'Chef' },
    { id: 'face6', label: 'Estrella' },
    { id: 'face7', label: 'Corazon' },
    { id: 'face8', label: 'Rayo' },
    { id: 'face9', label: 'Gato' },
    { id: 'face10', label: 'Robot' },
    { id: 'face11', label: 'Alien' },
    { id: 'face12', label: 'Ninja' },
  ];

  readonly bgColors: { color: string; label: string }[] = [
    { color: '#22C55E', label: '#22C55E' },
    { color: '#121212', label: 'Negro' },
    { color: '#E74C3C', label: 'Rojo' },
    { color: '#3498DB', label: 'Azul' },
    { color: '#2ECC71', label: 'Verde' },
    { color: '#9B59B6', label: 'Morado' },
    { color: '#E67E22', label: 'Naranja' },
    { color: '#1ABC9C', label: 'Turquesa' },
    { color: '#E91E63', label: 'Rosa' },
    { color: '#607D8B', label: 'Gris' },
  ];

  open(): void {
    this.selectedAvatar = this.currentAvatar.avatarId;
    this.selectedBg = this.currentAvatar.bgColor;
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  selectAvatar(id: string): void {
    this.selectedAvatar = id;
  }

  selectBg(color: string): void {
    this.selectedBg = color;
  }

  confirm(): void {
    const config: AvatarConfig = {
      avatarId: this.selectedAvatar,
      bgColor: this.selectedBg,
    };
    this.currentAvatar = config;
    this.avatarChanged.emit(config);
    this.isOpen = false;
  }
}
